
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "i18n!profiles.add_link_row";
import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'profiles/addLinkRow';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, functionType="function", escapeExpression=this.escapeExpression, helperMissing=helpers.helperMissing, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    <th scope=\"row\">\n      <input aria-label=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" type=\"text\" class=\"ic-Input\" maxlength=\"255\" name=\"link_titles[]\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n    </th>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <th scope=\"row\"><input aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("profiles.add_link_row")
  },data:data},helper ? helper.call(depth0, "Link Title", options) : helperMissing.call(depth0, "t", "Link Title", options)))
    + "\" type=\"text\" class=\"ic-Input\" maxlength=\"255\" name=\"link_titles[]\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></th>\n  ";
  return buffer;
  }

  buffer += "<tr>\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.title)),stack1 == null || stack1 === false ? stack1 : stack1.length), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <td aria-hidden=\"true\">→</td>\n  <td><input aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("profiles.add_link_row")
  },data:data},helper ? helper.call(depth0, "Link Url", options) : helperMissing.call(depth0, "t", "Link Url", options)))
    + "\" type=\"text\" class=\"ic-Input\" name=\"link_urls[]\" value=\"";
  if (helper = helpers.url) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.url); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\"></td>\n  <td><a href=\"#\" class=\"remove_link_row\" data-event=\"removeLinkRow\"><span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'scope': ("profiles.add_link_row")
  },data:data},helper ? helper.call(depth0, "Remove", options) : helperMissing.call(depth0, "t", "Remove", options)))
    + "</span><i class=\"icon-end\"></i></a></td>\n</tr>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  